import { render } from "./CV.vue?vue&type=template&id=17fbf4ae&ts=true"
import script from "./CV.vue?vue&type=script&lang=ts"
export * from "./CV.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/shunta/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__